import { StorageHandler } from "../../types/storage";
import { isOfficeContext } from "../../utils/context";
import { BrowserStorageHandler } from "./browserStorage";
import { OfficeStorageHandler } from "./officeStorage";

export class StorageService {
  private static instance: StorageService;
  private handler: StorageHandler;

  private constructor() {
    this.handler = isOfficeContext()
      ? new OfficeStorageHandler()
      : new BrowserStorageHandler();
  }

  public static getInstance(): StorageService {
    if (!StorageService.instance) {
      StorageService.instance = new StorageService();
    }
    return StorageService.instance;
  }

  public getHandler(): StorageHandler {
    return this.handler;
  }
}
